import { LiveHubFileSystemResponse, LiveHubUploadFileResponse } from './../models/livehub/file.system';
import { LiveHubWMIBrowseResponse } from './../models/livehub/wmi';
import { LiveHubBrowseRegistryResponse, LiveHubRegistryResponse } from './../models/livehub/registry';
import { Injectable } from '@angular/core';
import * as signalR from '@aspnet/signalr';
import { Observable, Subject } from 'rxjs';
import { Console } from 'console';
import { FileProgress } from '@models/livehub/file.progress';
import { UpdateSuccess } from '@models/livehub/update.success';

export enum EventTypes {
    UpdatePackageBuildStatus = 0,
    UpdatePackageBuildCompleted = 1,
    LiveHubConnectionsChanged = 2
}

@Injectable()
export class LiveHubService {

    // public onAdminPresenceChanged = new Subject<bool>();
    private ApiKey = 'Skfhk248Fausto754WJsdCaltabiano5#74';
    private _hubURL = '';
    // private _hubURL = "http://localhost:19012/AdminHub";
    public _hubConnection;
    public hubConnected = false;
    private connectionAttempts = 0;

    // Observables
    public FileSystemBrowseResponse: Subject<LiveHubFileSystemResponse> = new Subject();
    public UploadFileSystemResponse: Subject<any> = new Subject();
    public WMIBrowseResponse: Subject<LiveHubWMIBrowseResponse> = new Subject();
    public RegistryBrowseResponse: Subject<LiveHubBrowseRegistryResponse> = new Subject();
    public RegistryResponse: Subject<LiveHubRegistryResponse> = new Subject();
    public LicenseStatusUpdate: Subject<any> = new Subject();
    public LicenseConnectionStatusUpdate: Subject<any> = new Subject();
    public GetPackageStatus: Subject<any> = new Subject();
    public ResetLiveHubResponse: Subject<any> = new Subject();
    public IgnoreHardwareCheckChangedResponse: Subject<any> = new Subject();
    public KillLicensePoolStudioResponse: Subject<any> = new Subject();
    public ReinstallLiveHubResponse: Subject<any> = new Subject();
    public OnFileUploadProgress: Subject<FileProgress> = new Subject();
    public UploadDatabaseLogsResponse: Subject<any> = new Subject();
    public PushNewestUpdateResponse: Subject<any> = new Subject();
    public UpdateSuccess: Subject<any> = new Subject();

    constructor() {
       this._hubURL = this.GetLiveHubURL();
       this.StartConnection(); // debug prevent connection
    }

    GetLiveHubURL() {
        return "https://livehub-connect.structurestudios.com/AdminHub";
        //return "https://localhost:44300/AdminHub"
        //return 'https://livehub-connect-v3.structurestudios.com/AdminHub';// 'https://livehub-connect-v3.structurestudios.com/AdminHub';

      //  switch (window.location.hostname) {

      //      case 'ssdb.structurestudios.com': return 'https://livehub-connect-v3.structurestudios.com/AdminHub';
      //      case 'ssdb-dev.structurestudios.com': return 'https://livehub-connect-v3-dev.structurestudios.com/AdminHub';
      //      default: return 'https://livehub-connect-v3.structurestudios.com/AdminHub'; // 'https://localhost:44361/AdminHub';
      //  }
    }

    public StartConnection() {


        var isAuthenticated = localStorage.getItem('is_authenticated');

        if (isAuthenticated != "1") {
            setTimeout(() => { this.StartConnection(); }, 2500);
            return false;
        }

        const Token = localStorage.getItem('crm_token');
        
        console.log("token=", Token);
        
        this._hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(this._hubURL,
                {
                    accessTokenFactory: function () { return Token; },
                    skipNegotiation: true,
                    transport: signalR.HttpTransportType.WebSockets,                    
                })
            .build();


        console.log("Starting Connection to " + this._hubURL);
        this._hubConnection
            .start()
            .then(() => {
                console.log("Connected");
                this.hubConnected = true;
                this.InitLicenseEvents();
            })
            .catch(err => {
                if (this.connectionAttempts <= 5) {
                    setTimeout(() => { this.StartConnection(); this.connectionAttempts++; }, 5000);
                } else if (localStorage.getItem('ss-dev-mode')) {
                    setTimeout(() => { this.StartConnection(); this.connectionAttempts++; }, 2000 * this.connectionAttempts);
                }
                console.log("Error connecting: ", err);
            });

        this._hubConnection.onclose(() => {
            setTimeout( () => {
                this.StartConnection();
            }, 10000 );
            console.log("Connection Closed");
        });
    }

    public InvokeConnection(event: String, type?, id?, other?) {
        console.log("Invoke Connection: ", event, type, id, other);
        if (this.hubConnected) {
            if (other) {
                this._hubConnection.invoke(event, type, id, other).then( () => {} ).catch(err => {
                    this.StartConnection();
                });
            } else if (id) {
                this._hubConnection.invoke(event, type, id).then(() => {}).catch(err => {
                    this.StartConnection();
                });
            } else if (type) {
                this._hubConnection.invoke(event, type).then(() => { }).catch(err => {
                    this.StartConnection();
                });
            } else {
                this._hubConnection.invoke(event).then(() => {}).catch(err => {
                    this.StartConnection();
                });
            }
        } else (
            setTimeout(() => {
                this.InvokeConnection(event, type, id);
            }, 30000)
        );
    }

    public InitLicenseEvents() {
        this._hubConnection.on('WMIBrowseResponse', (message: LiveHubWMIBrowseResponse) => {
            console.log("WMIBrowseResponse", message);
            this.WMIBrowseResponse.next(message);
        });

        this._hubConnection.on('RegistryBrowseResponse', (message: LiveHubBrowseRegistryResponse) => {
            console.log(message);
            this.RegistryBrowseResponse.next(message);
        });

        this._hubConnection.on('RegistryResponse', (message: LiveHubRegistryResponse) => {
            console.log(message);
            this.RegistryResponse.next(message);
        });

        this._hubConnection.on('LicenseStatusUpdate', message => {
            console.log(message);
            this.LicenseStatusUpdate.next(message);
        });

        this._hubConnection.on('LicenseConnectionStatusUpdate', message => {
            console.log("LicenseConnectionStatusUpdate", message);
            this.LicenseConnectionStatusUpdate.next(message);
        });

        this._hubConnection.on('IgnoreHardwareCheckChangedResponse', message => {
            console.log("IgnoreHardwareCheckChangedResponse", message);

            this.IgnoreHardwareCheckChangedResponse.next(message);
        });

        this._hubConnection.on('UpdateSuccess', (message: UpdateSuccess) => {
            console.log("We succeeded");
            console.log("UpdateSuccess", message);

            this.UpdateSuccess.next(message);
        });

        this._hubConnection.on('ResetLicenseLiveHubResponse', message => {
            console.log(message);
            this.ResetLiveHubResponse.next(message);
        });

        this._hubConnection.on('StopPoolStudioResponse', message => {
            console.log(message);
            this.KillLicensePoolStudioResponse.next(message);
        });

        this._hubConnection.on('ReinstallLiveHubResponse', message => {
            console.log(message);
            this.ReinstallLiveHubResponse.next(message);
        });

        this._hubConnection.on('FileProgressResponse', message =>{
            this.OnFileUploadProgress.next(message);
        })

        this._hubConnection.on('UploadDatabaseLogsResponse', message =>{
            console.log("UploadDatabaseLogsResponse", message);
            this.UploadDatabaseLogsResponse.next(message);
        })

        this._hubConnection.on('PushVersionComplete', message =>{
            console.log("PushVersionComplete", message);
            this.PushNewestUpdateResponse.next(message);
        })

    }

}